var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#8FD460"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 38.3473C34.6222 38.3473 38.3473 34.6223 38.3473 28C38.3473 21.3778 34.6222 17.6528 28 17.6528C21.3778 17.6528 17.6527 21.3778 17.6527 28C17.6527 34.6223 21.3778 38.3473 28 38.3473Z",
    stroke: "white",
    strokeWidth: 1.7136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7761 23.7737C23.5222 24.7401 22.7144 26.257 22.7144 27.9625C22.7144 30.8816 25.0809 33.2481 28 33.2481C30.9191 33.2481 33.2855 30.8816 33.2855 27.9625C33.2855 26.257 32.4778 24.7401 31.2239 23.7737",
    stroke: "white",
    strokeWidth: 1.7136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 22.2045V26.9959",
    stroke: "white",
    strokeWidth: 1.7136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerButton);
export default __webpack_public_path__ + "static/media/powerButton.4daf1a73ad4bf23fa062dcad4cf8a05d.svg";
export { ForwardRef as ReactComponent };